import React, { useEffect, useState } from 'react'
import { ThreeCanvas } from './InitThreeJsScene'
import { Canvas } from '@react-three/fiber'
import { Scene } from './Scene'
import { Link } from 'react-router-dom'
/*Generate Button*/
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

export const Root = () => {

    const VisuallyHiddenInput = styled('input')({
                clip: 'rect(0 0 0 0)',
                clipPath: 'inset(50%)',
                height: 1,
                overflow: 'hidden',
                position: 'absolute',
                bottom: 0,
                left: 0,
                whiteSpace: 'nowrap',
                width: 1,
              });
    

    useEffect(()=>{
        
        
    },[])
  return (
    <>
    <div className='flex h-[100%] w-[100%] bg-[#17293F] flex-col'>
          {/* Top Bar Studio area */
                    <div
          className="
            flex h-[8%] w-full p-2
            items-center justify-center
            bg-white/10
            backdrop-blur-md
            border-b border-white/20
            shadow-lg
          "
        >
          <div className="w-[30%] h-full pl-4 flex items-center hover:cursor-pointer">
            <h1 className="text-white text-2xl font-bold">Autofarmis</h1>
          </div>

          <div className="text-white w-[40%] h-full flex justify-between items-center">
            <Link className="border border-white/30 px-4 py-2 rounded-lg hover:bg-white/10 transition">
              showcase
            </Link>
            <Link className="border border-white/30 px-4 py-2 rounded-lg hover:bg-white/10 transition">
              docs
            </Link>
            <Link className="border border-white/30 px-4 py-2 rounded-lg hover:bg-white/10 transition">
              solutions
            </Link>
          </div>

          <div className="text-white w-[30%] h-full flex justify-end items-center">
            <Link
              className="border border-white/30 px-4 py-2 rounded-lg hover:bg-white/10 transition"
              to="login"
            >
              Login
            </Link>
          </div>
        </div>
          }
          {
                <div
      className="
        text-white 
        w-full 
        h-[92%] 
        flex
        bg-[url('https://framerusercontent.com/images/mZvOw3hxVFOTDbP0b2Wt76YqlM.png')]
        bg-cover
        bg-center
        bg-no-repeat
      "
    >
      <div className="h-full w-1/2 items-center justify-center flex flex-col">
        <h1 className="text-6xl text-center mb-2 font-bold">
          Autofarmis
        </h1>

        <h1 className="text-2xl text-center">
          Create Maps, Analyze Data & Visualize Insights
        </h1>

        <div className="mt-3">
          <Stack spacing={2} direction="row">
            <Button variant="contained">Get Started</Button>
          </Stack>
        </div>
      </div>

      <div className="h-full w-1/2 items-center justify-center flex flex-col">
        
      </div>
    </div>

          }
    </div>
      
  
    </>)
        
}